<template>
    <div class="schd_wrapper">
        <div class="  padding-b-x">
            <!--学习历史明细-->
            <div class="schd_title_wrapper">
                <a class="schd_title_1" href="javaScript:;" @click="$router.push('/lifeCourse/studyHistory')">学习历史 &gt;</a>
                <span class="schd_title_2">明细</span>
            </div>
            <div class="schd_time_line_wrapper margin-top commonBackground">
                <ul class="schd_time_line_wrapper">
                    <div v-for="(item,indexF) in activities" :key="indexF">
                        <li class="schd_time_line_date">
                            <span class="schd_line_data_text">{{item.dayTitle}}</span>
                            <div class="schd_line_date_cicle_wrapper">
                                <div class="schd_line_data_top_empty"></div>
                                <div class="schd_line_date_circle"></div>
                                <div class="schd_divider"></div>
                            </div>
                        </li>

                        <li v-for="(itemS,indexS) in item.courseRecordDetails" :key="indexS" class="schd_time_line_content">
                            <span class="schd_time_line_content_left">{{itemS.timeTitle}}</span>
                            <div class="schd_time_line_content_divider">
                                <div class="schd_divider"></div>
                            </div>
                            <div class="schd_time_line_content_right">
                                <div class="schd_time_right_title_wrapper">
                                    <div class="schd_right_title1">{{itemS.albumTitle}}</div>
                                    <div class="schd_right_title2">{{itemS.videoTitle}}</div>
                                </div>
                                <div class="schd_right_watch_time">{{itemS.durationStr}}</div>
                                <div class="schd_right_watch_terminal">{{itemS.clientTerminal}}</div>
                            </div>
                        </li>
                    </div>
                    <li class="schd_time_line_end"><span class="schd_end_text">没有更多了</span>
                        <div class="schd_end_circle_wrapper">
                            <div class="schd_end_divider"></div>
                            <div class="schd_end_circle"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {latelyTimeLearnLogDetail} from "../../../config";

    export default {
        name: "studyHistoryDetail",
        data() {
            return {
                reverse: true,
                activities: []
            };
        },
        mounted(){
          this.lookMx();
        },
        methods:{
            async lookMx(){
                let result=await latelyTimeLearnLogDetail();
                if(result.status){
                    this.activities=result.data;
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .schd_wrapper {
        height: 100%;
        .schd_title_wrapper {
            padding-top: 24px;
            padding-left: 24px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;

            .schd_title_1 {
                font-size: 14px;
                color: #A7ACB9;
            }

            .schd_title_2 {
                font-size: 14px;
                color: #2E86FF;
                margin-left: 2px;
            }
        }

        .schd_time_line_wrapper {
            height: calc(100vh - 100px);
            padding-top:10px;
            .schd_divider {
                width: 1px;
                height: 100%;
                background: #E8EDF3;
            }
            .schd_time_line_date {
                display: flex;
                height: 45px;
                .schd_line_data_text {
                    width: 110px;
                    font-size: 14px;
                    color: #2E86FF;
                    text-align: right;
                }
                .schd_line_date_cicle_wrapper {
                    margin-left: 30px;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    .schd_line_data_top_empty {
                        height: 8px;
                        width: 1px;
                    }
                    .schd_line_date_circle {
                        width: 10px;
                        height: 10px;
                        flex-shrink: 0;
                        background: #ffffff;
                        border-radius: 50%;
                        border: 2px solid #2E86FF;
                    }
                    .schd_divider {
                        width: 1px;
                        height: 100%;
                        background: #E8EDF3;
                    }
                }
            }
            .schd_time_line_content {
                display: flex;
                height: 66px;
                .schd_time_line_content_left {
                    width: 110px;
                    text-align: right;
                    font-size: 14px;
                    font-weight: 400;
                    color: #A7ACB9;
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                }
                .schd_time_line_content_divider {
                    margin-left: 30px;
                    width: 10px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    flex-shrink: 0;
                }
                .schd_time_line_content_right {
                    width: 100%;
                    padding-top: 2px;
                    position: relative;
                    .schd_time_right_title_wrapper {
                        margin-left: 30px;
                        .schd_right_title1 {
                            font-size: 16px;
                            font-weight: 500;
                            line-height: 18px;
                            color: #2A333A;
                            max-width: 600px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .schd_right_title2 {
                            font-size: 14px;
                            font-weight: 400;
                            margin-top: 10px;
                            max-width: 550px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            color: #A7ACB9;
                        }
                    }
                    .schd_right_watch_time {
                        position: absolute;
                        right: 60px;
                        top: 0;
                        font-size: 14px;
                        font-weight: 400;
                        color: #A7ACB9;
                    }
                    .schd_right_watch_terminal {
                        font-size: 14px;
                        font-weight: 400;
                        color: #A7ACB9;
                        position: absolute;
                        top: 0;
                        right: 160px;
                    }
                }
            }
            .schd_time_line_end {
                display: flex;
                .schd_end_text {
                    width: 110px;
                    text-align: right;
                    font-size: 14px;
                    font-weight: 400;
                    color: #A7ACB9;
                }
                .schd_end_circle_wrapper {
                    width: 10px;
                    margin-left: 30px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    .schd_end_circle {
                        width: 6px;
                        height: 6px;
                        background: #A7ACB9;
                        border-radius: 50%;
                    }
                }
            }

        }
    }
</style>
